// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS pour la barre de progression
 */

.progression-bar-container {
  background: #fff;
  border-radius: 0.75rem;
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-width: 280px;
}

.progression-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.progression-percentage {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
}

.progression-status {
  font-size: 1.2rem;
  font-weight: 500;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
}

.progression-status.status-visible {
  background: #dcfce7;
  color: #166534;
}

.progression-status.status-pending {
  background: #fef3c7;
  color: #92400e;
}

.progression-status.status-incomplete {
  background: #fee2e2;
  color: #991b1b;
}

.progression-track {
  height: 8px;
  background: #e5e7eb;
  border-radius: 9999px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progression-fill {
  height: 100%;
  border-radius: 9999px;
  transition: width 0.5s ease-out, background-color 0.3s ease;
}

.progression-legend {
  display: flex;
  justify-content: space-between;
  font-size: 1.1rem;
  color: #6b7280;
}

.legend-info {
  color: #f59e0b;
  font-weight: 500;
}

.legend-success {
  color: #22c55e;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/components/ProgressionBar.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/**\n * CSS pour la barre de progression\n */\n\n.progression-bar-container {\n  background: #fff;\n  border-radius: 0.75rem;\n  padding: 1rem 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  min-width: 280px;\n}\n\n.progression-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.progression-percentage {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.progression-status {\n  font-size: 1.2rem;\n  font-weight: 500;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n}\n\n.progression-status.status-visible {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.progression-status.status-pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.progression-status.status-incomplete {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.progression-track {\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 9999px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progression-fill {\n  height: 100%;\n  border-radius: 9999px;\n  transition: width 0.5s ease-out, background-color 0.3s ease;\n}\n\n.progression-legend {\n  display: flex;\n  justify-content: space-between;\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n.legend-info {\n  color: #f59e0b;\n  font-weight: 500;\n}\n\n.legend-success {\n  color: #22c55e;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
